<template>
  <div class="wrapper">
    <div class="t bgw">
      <div class="shop-container">
        <router-link to="/">
          <div class="logo-icon">
            <img :src="this.$store.state.config.shop_logo" alt>
          </div>
          <div class="logo-text">{{this.$store.state.config.shop_name}}</div>
        </router-link>
      </div>
    </div>
    <div class="main shop-container">
      <div class="timetip bgw">
        <i class="icon iconfont iconerror"></i>请在
        <template>
          <span>{{hour? hourString+':'+minuteString+':'+secondString : minuteString+':'+secondString}}</span>
        </template>
        时间内完成支付，超时订单将会自动取消
      </div>
      <div class="count-title bgw">
        <div class="l">
          <div class="head">项目：</div>
          <div class="item-list">
            <div v-for="(item,index) in orderInfo.items" :key="index" class="item-li">{{item.name}}</div>
          </div>
        </div>
        <div class="total">
          应付金额￥
          <span class="total-money">{{orderInfo.order_amount}}</span>
        </div>
      </div>
      <div class="pay-box bgw">
        <div class="title">选择支付方式</div>
        <div class="box-info">
          <el-radio-group v-model="payType">
            <el-radio :label="item.code" v-for="(item,index) in payments" :key="index">
              <span class="pay-type" :class="{'active':payType==item.code}">
                <i class="icon iconfont iconxianxiamendian" v-if="item.code=='offline'"></i>
                <i class="icon iconfont iconyuezhifu" v-else-if="item.code=='balancepay'"></i>
                <i class="icon iconfont iconzhifubao" v-else-if="item.code=='alipay'"></i>
                <i class="icon iconfont iconweixinzhifu" v-else-if="item.code=='wechatpay'"></i>
                <i class="icon iconfont iconhelipay" v-else-if="item.code=='helipay'"></i>
                <i class="icon iconfont iconhelipay" v-else-if="item.code=='yishengpay'"></i>
                {{item.name}}
              </span>
            </el-radio>
          </el-radio-group>
          <div>暂无支付方式，请在手机端进行支付</div>
        </div>
        <div class="pay-block">
          <div class="pay-info">
            支付￥
            <span class="total-money">{{orderInfo.order_amount}}</span>
          </div>
        </div>
        <div class="pay-block" style="display:none;">
          <el-button class="pay-btn" :loading="btnLoading" @click="toPay">去付款</el-button>
        </div>
      </div>
    </div>
    <template v-if="dialogPaymentShow">
      <Payment :codeImg="code_url" @clearInterPay="clearInterPay"></Payment>
    </template>
    <template v-if="dialogHelipayShow">
      <Alipay :codeImg="qrcode" @clearInterPay="clearInterPay" :orderAmount="orderAmount"></Alipay>
    </template>
  </div>
</template>

<script>
import Payment from '@/components/payment.vue'
import Alipay from '@/components/alipay.vue'
import { locationHost } from '@/config/env.js'
export default {
  name: 'Cashier',
  components: { Payment, Alipay },
  props: {},
  data() {
    return {
      payments: [],
      payType: 'yishengpay',
      orderInfo: {},
      code_url: '',
      dialogPaymentShow: false,
      intervalPayStatus: '',
      remainingTime: '',
      hour: '',
      minute: '',
      second: '',
      promiseTimer: '',
      btnLoading: false, // 禁用btn
      qrcode: '',
      dialogHelipayShow: false,
      orderAmount: 0.0,
    }
  },
  watch: {},
  computed: {
    hourString() {
      return this.formatNum(this.hour)
    },
    minuteString() {
      return this.formatNum(this.minute)
    },
    secondString() {
      return this.formatNum(this.second)
    },
  },
  methods: {
    toPay() {
      this.btnLoading = true
      let code = this.payType
      if (code == 'wechatpay') {
        let data = {
          ids: this.order_id,
          payment_code: code,
          payment_type: 1,
          params: {
            trade_type: 'NATIVE',
          },
        }
        // 微信h5支付
        this.$api
          .pay(data)
          .then(res => {
            this.btnLoading = false
            // if (res.status) {
            this.dialogPaymentShow = true
            this.code_url = res.data.code_url
            this.getPaymentStatus(res.data.payment_id)
            // } else {
            //   this.$msg(res.msg, "error");
            // }
          })
          .catch(() => {
            this.btnLoading = false
          })
      } else if (code == 'alipay') {
        let data = {
          ids: this.order_id,
          payment_code: code,
          payment_type: 1,
          params: {
            trade_type: 'PC',
            return_url: locationHost + '/#/cashier/' + this.order_id,
          },
        }
        this.$api
          .pay(data)
          .then(res => {
            this.btnLoading = false
            if (res.status) {
              this.standarPost(res.data.url, res.data.data)
            }
          })
          .catch(() => {
            this.btnLoading = false
          })
      } else if (code == 'balancepay') {
        let data = {
          ids: this.order_id,
          payment_code: code,
          payment_type: 1,
        }
        this.$api
          .pay(data)
          .then(res => {
            this.btnLoading = false
            console.log(res)
            if (res.status && res.msg == '支付成功') {
              this.$msg('支付成功')
              this.toPaySuccess()
            } else {
              this.$msg(res.msg, 'warning')
            }
          })
          .catch(() => {
            this.btnLoading = false
          })
      } else if (code == 'offline') {
        this.$confirm('请联系客服进行线下支付', '线下支付说明', {
          confirmButtonText: '订单详情',
          cancelButtonText: '继续购物',
          type: 'info',
        })
          .then(() => {
            this.btnLoading = false
            this.$router.replace({
              name: 'orderDetail',
              params: { order_id: this.order_id },
            })
          })
          .catch(() => {
            this.btnLoading = false
            this.$router.replace({ name: 'home' })
          })
      } else if (code == 'helipay') {
        let data = {
          ids: this.order_id,
          payment_code: 'helipay',
          payment_type: 1,
          params: {
            trade_type: 'ALIPAYSCAN',
          },
        }
        this.$api
          .pay(data)
          .then(res => {
            this.btnLoading = false
            if (res.status) {
              this.dialogHelipayShow = true
              this.qrcode = res.data.qrcode
              this.getPaymentStatus(res.data.payment_id)
            } else {
              this.$msg(res.msg, 'error')
            }
          })
          .catch(() => {
            this.btnLoading = false
          })
      } else if (code == 'yishengpay') {
        let data = {
          ids: this.order_id,
          payment_code: 'yishengpay',
          payment_type: 1,
          params: {
            trade_type: 'qrPay',
          },
        }
        this.$api
          .pay(data)
          .then(res => {
            this.btnLoading = false
            if (res.status) {
              this.dialogHelipayShow = true
              this.qrcode = res.data.qrcode
              this.getPaymentStatus(res.data.payment_id)
            } else {
              this.$msg(res.msg, 'error')
            }
          })
          .catch(() => {
            this.btnLoading = false
          })
      } else {
        this.btnLoading = false
        this.$msg('支付方式错误', 'warning')
      }
    },
    standarPost(url, data) {
      let tempForm = document.createElement('form')
      tempForm.id = 'aliPay'
      tempForm.methods = 'post'
      tempForm.action = url
      tempForm.target = '_self'
      let input = []
      for (let k in data) {
        input[k] = document.createElement('input')
        input[k].type = 'hidden'
        input[k].name = k
        input[k].value = data[k]
        tempForm.appendChild(input[k])
      }
      tempForm.addEventListener('submit', function() {}, false)
      document.body.appendChild(tempForm)
      tempForm.dispatchEvent(new Event('submit'))
      tempForm.submit()
      document.body.removeChild(tempForm)
    },
    clearInterPay() {
      clearInterval(this.intervalPayStatus)
      this.dialogPaymentShow = false
      if (this.dialogHelipayShow) {
        this.dialogHelipayShow = false
      }
    },
    toPaySuccess() {
      this.$router.replace({
        name: 'paySuccess',
        query: { order_id: this.order_id },
      })
    },
    getPaymentStatus(id) {
      let data = {
        payment_id: id,
      }
      let that = this
      this.intervalPayStatus = setInterval(function() {
        that.$api.paymentInfo(data).then(res => {
          if (res.status) {
            if (res.data.status == 2) {
              that.$msg('支付成功')
              that.toPaySuccess()
            }
          }
        })
      }, 1000)
    },
    getPaymentType() {
      this.$api.paymentList().then(res => {
        let data = res.data
        this.payments = data
        if (data.length > 0 && this.payType == '') {
          this.payType = data[0]['code']
        }
        console.log(this.payments)
        this.payments.forEach(item => {
          if (item.code == 'helipay' || item.code == 'yishengpay') {
            item.name = '支付宝支付'
          }
        })
      })
    },
    getOrderDetail() {
      let data = {
        order_id: this.order_id,
      }
      this.$api.orderDetail(data).then(res => {
        if (res.status) {
          this.orderInfo = res.data
          this.orderAmount = res.data.order_amount
          console.dir(res.data)
          let remainingTime = res.data.remaining_time
          this.remainingTime = remainingTime
          this.getCountDownTime(remainingTime)
          if (res.data.pay_status == 2) {
            this.toPaySuccess()
          }
        }
      })
    },
    getCountDownTime(time) {
      if (Number(time) > 0) {
        this.hour = Math.floor(time / 3600)
        this.minute = Math.floor((time / 60) % 60)
        this.second = Math.floor(time % 60)
        this.countDown()
      }
    },
    countDown() {
      let that = this
      clearInterval(this.promiseTimer)
      this.promiseTimer = setInterval(function() {
        if (that.hour === 0) {
          if (that.minute !== 0 && that.second === 0) {
            that.second = 59
            that.minute -= 1
          } else if (that.minute === 0 && that.second === 0) {
            that.second = 0
            clearInterval(that.promiseTimer)
          } else {
            that.second -= 1
          }
        } else {
          if (that.minute !== 0 && that.second === 0) {
            that.second = 59
            that.minute -= 1
          } else if (that.minute === 0 && that.second === 0) {
            that.hour -= 1
            that.minute = 59
            that.second = 59
          } else {
            that.second -= 1
          }
        }
      }, 1000)
    },
    formatNum(num) {
      return num < 10 ? '0' + num : ' ' + num
    },
  },
  created() {},
  mounted() {
    let orderId = this.$route.params.order_id
    this.order_id = orderId
    //this.getPaymentType()
    this.getOrderDetail()
  },
  destroyed() {
    clearInterval(this.promiseTimer)
    clearInterval(this.intervalPayStatus)
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
@import '@/assets/css/mixin.scss';
.wrapper {
  .main {
    .timetip {
      height: 40px;
      line-height: 40px;
      text-align: center;
      margin: 16px auto;
      color: #757575;
      .icon {
        color: #757575;
        margin-right: 5px;
      }
    }
    .count-title {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 14px;
      margin-bottom: 10px;
      .l {
        display: inline-flex;
        .head {
          width: 60px;
          height: 30px;
          line-height: 30px;
        }
        .item-list {
          .item-li {
            height: 30px;
            line-height: 30px;
          }
        }
      }
      .total {
        color: $theme-color;
        font-size: 12px;
        height: 30px;
        line-height: 30px;
        &-money {
          font-size: 24px;
        }
      }
    }
    .pay-box {
      padding: 14px;
      margin-bottom: 20px;
      .title {
        margin-bottom: 20px;
      }
      .box-info {
        display: flex;
        margin-bottom: 40px;
        .pay-type {
          display: inline-block;
          width: 130px;
          height: 36px;
          line-height: 32px;
          text-align: center;
          border: 1px solid $border;
          transition: all 0.2s;
          cursor: pointer;
          padding: 1px;
          box-sizing: border-box;
          &.active,
          &:hover {
            border-color: $theme-color;
          }
        }
      }
      .pay-block {
        height: 50px;
        .pay-info {
          float: right;
          color: $theme-color;
          .total-money {
            font-size: 24px;
          }
        }
        .pay-btn {
          float: right;
          // width: 90px;
          // height: 32px;
          line-height: 6px;
          border-radius: 16px;
          text-align: center;
          background: $theme-color;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }

  .t {
    border-bottom: 2px solid $theme-color;
    height: 100px;
    .shop-container {
      padding-top: 30px;
      .logo-icon {
        float: left;
        width: 48px;
        height: 48px;
        margin-right: 10px;
        img {
          width: 100%;
          height: auto;
        }
      }
      .logo-text {
        float: left;
        margin-top: 0px;
        font-size: 20px;
        color: #424242;
        line-height: 48px;
        margin-right: 20px;
      }
      .tip {
        float: left;
        line-height: 20px;
        margin-top: 20px;
        font-size: 12px;
        color: #757575;
      }
      .group {
        float: right;
        margin-top: 20px;
        display: flex;
        color: #757575;
        font-size: 12px;
        .item {
          height: 40px;
          line-height: 40px;
          cursor: pointer;
        }
        .line {
          height: 20px;
          line-height: 20px;
          color: #757575;
          margin-top: 10px;
          margin: 10px 10px 0;
        }
      }
    }
  }
}
</style>